// extracted by mini-css-extract-plugin
export default {"modalBody":"delete-tag-modal_modalBody__cBiM-","applyButton":"delete-tag-modal_applyButton__4+nLv"};